import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataWpServiceFaqTogglesHome } from '../../data-wp.service';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  animation
} from '@angular/animations';


@Component({
  selector: 'app-faq-toggles-home',
  templateUrl: './faq-toggles-home.component.html',
  styleUrls: ['./faq-toggles-home.component.css'],
  providers: [DataWpServiceFaqTogglesHome],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('collapseAnim', [
      state('open', style({ height: '*', opacity: 1, padding: '*'})),
      state('closed', style({ height: '0px', opacity: 0, padding: '0px 1.25rem' })),
      transition('open <=> closed', [animate('300ms ease-in-out')])
    ])
  ]
})
export class FaqTogglesHomeComponent implements OnInit {

  constructor(private dataWp: DataWpServiceFaqTogglesHome) { }
  openIndex: number | null = null;
  faqItems: any[] = [];
  titulo: string = '';
subtitulo: string = '';
ngOnInit() {
    this.dataWp.getPosts().subscribe((posts: any) => {
      console.log('Posts recibidos:', posts);
      
      if (posts && posts.length > 0 && posts[0].acf) {
        const acf = posts[0].acf;
        
        // Extraer título y subtítulo
        this.titulo = acf.titulo || '';
        this.subtitulo = acf.subtitulo || '';
        
        // Extraer las preguntas y respuestas del campo acf.combo
        if (acf.combo) {
          this.faqItems = acf.combo.map((item: any) => ({
            pregunta: item.pegunta, // Nota: en la respuesta está escrito "pegunta" (con error tipográfico)
            respuesta: item.respuesta
          }));
        }
      }
    });
  }

  toggle(index: number) {
    this.openIndex = this.openIndex === index ? null : index;
  }

  isOpen(index: number): boolean {
    return this.openIndex === index;
  }
}
